import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import './styles.css';

interface Props {
  text?: string;
  onClick: () => void;
  description?: string;
}

const VoltarButton: React.FC<Props> = ({ text = 'Voltar', onClick, description }) => {

  const accessibility = useAccessibility();

  return (
    <button
      className="back-button-accessibility"
      style={accessibility.textStyleAccessibility}
      onClick={onClick}
      aria-label={description ?? 'voltar'}
    >
      <FontAwesomeIcon icon={faChevronLeft} className='back-button-icon'/>&nbsp;&nbsp;<u>{text}</u>
    </button>
  )
}

export default VoltarButton;